export default "__VITE_ASSET__C2L8XCLf__"